import { TranslationKey } from '../types/translation-types';

export interface SearchResult {
  filteredItems: TranslationKey[];
  totalMatches: number;
}

/**
 * Search translations locally across all columns.
 * Searches: keyName, description, and all language values.
 * Case-insensitive matching.
 */
export function searchTranslationsLocally(
  translations: TranslationKey[],
  query: string
): SearchResult {
  if (!query.trim()) {
    return {
      filteredItems: translations,
      totalMatches: translations.length,
    };
  }

  const normalizedQuery = query.toLowerCase().trim();

  const filteredItems = translations.filter((translation) => {
    // Search keyName
    if (translation.keyName.toLowerCase().includes(normalizedQuery)) {
      return true;
    }

    // Search description
    if (translation.description?.toLowerCase().includes(normalizedQuery)) {
      return true;
    }

    // Search all language values
    for (const value of translation.values) {
      if (value.value.toLowerCase().includes(normalizedQuery)) {
        return true;
      }
    }

    return false;
  });

  return {
    filteredItems,
    totalMatches: filteredItems.length,
  };
}

/**
 * Paginate filtered results.
 */
export function paginateResults(
  items: TranslationKey[],
  page: number,
  pageSize: number
): TranslationKey[] {
  const start = page * pageSize;
  return items.slice(start, start + pageSize);
}
